import * as ActionTypes from 'actions';
import Calendar from 'lib/Calendar';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  events: {
    all: {},
    list: [],
    day: [],
    week: [],
    month: [],
  },
  isLoading: false,
  filter: {},
  response: {},
  search: '',
};

export default function(state = initialState, action = {}) {
  const { type, view, response, filter, id, error, payload, search } = action;
  const { events } = state;

  switch (type) {
  case ActionTypes.SET_EVENTS_SEARCH:
    return Object.assign({}, state, { search });

  case ActionTypes.SET_EVENTS_FILTER:
    return Object.assign({}, state, { filter });

  case ActionTypes.EVENTS_REQUEST:
    events[view] = [];
    return Object.assign({}, state, { events, filter, isLoading: true });

  case ActionTypes.EVENTS_SUCCESS: {
    const metadata = response.metadata ? response.metadata : {};
    events[view] = response.tfs_Event.map((event) => {
      const massaged = Calendar.massageEvent(event, metadata);
      events.all[event.id] = massaged;
      return massaged;
    });

    return Object.assign({}, state, { events, filter, response, isLoading: false });
  }

  case ActionTypes.EVENTS_FAILURE:
    console.error('Error loading events', error);

    return Object.assign({}, state, { response, isLoading: false });


  case ActionTypes.SINGLE_EVENT_REQUEST:
    events.all[id] = events.all[id] ? Object.assign({}, events.all[id], { isLoading: true }) : { isLoading: true };

    return Object.assign({}, state, { events });

  case ActionTypes.SINGLE_EVENT_SUCCESS: {
    const event = response.tfs_Event.length ? response.tfs_Event[0] : {};
    const metadata = response.metadata ? response.metadata : {};

    events.all[id] = Calendar.massageEvent(Object.assign(event, { isLoading: false, metadata }), metadata);

    return Object.assign({}, state, { events });
  }

  case ActionTypes.SINGLE_EVENT_FAILURE: {
    console.error('Error loading event', id, error);
    events.all[id] = { isLoading: false };

    return Object.assign({}, state, { events });
  }

  case ActionTypes.INBOX_MARK_CHANGE_APPROVED: {
    const { eventId, changeId, changeSetId } = payload;

    if (!events.all[eventId]) {
      return state;
    }

    let removeIndex = false;
    events.all[eventId].changes.forEach((change, index) => {
      if (change.change_id && change.change_id === changeId) {
        removeIndex = index;
      } else if (change.change_set_id && change.change_set_id === changeSetId) {
        removeIndex = index;
      }
    });

    if (removeIndex !== false) {
      const event = Object.assign({}, events.all[eventId]);
      event.changes.splice(removeIndex, 1);
      events.all[eventId] = event;

      return Object.assign({}, state, { events });
    }

    return state;
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/calendar.js